import type { DTOEventGatewayContext } from 'src/apis/dto/DTOEventGatewayContext';

import type { APIClientType } from '.';

export interface EventGatewayContextServiceType {
  get: (data?: {
    locationCountryCode?: string;
    localeCountryCode?: string;
    simCountryCode?: string;
  }) => Promise<DTOEventGatewayContext>;
}

export class EventGatewayContextService implements EventGatewayContextServiceType {
  private client: APIClientType;

  constructor(customClient: APIClientType) {
    this.client = customClient;
  }

  public get = ({
    locationCountryCode,
    localeCountryCode,
    simCountryCode,
  }: {
    locationCountryCode?: string;
    localeCountryCode?: string;
    simCountryCode?: string;
  } = {}) => {
    const searchParams = new URLSearchParams();

    if (locationCountryCode) {
      searchParams.append('locationCountryCode', locationCountryCode);
    }
    if (localeCountryCode) {
      searchParams.append('localeCountryCode', localeCountryCode);
    }
    if (simCountryCode) {
      searchParams.append('simCountryCode', simCountryCode);
    }

    return this.client.call<DTOEventGatewayContext, void>({
      method: 'GET',
      path: `/api/contexts/event-gateway?${searchParams}`,
    });
  };
}
